import {resourceSharingSvg as Icon__small__resourceSharingSvg} from '../Icon__small/Icon__small--resourceSharing.js';

export var resourceSharing = {
  name: 'resourceSharing',
  category: 'icon',
  colorable: true,
  svg: Icon__small__resourceSharingSvg,
};
